export enum EVinculoUnidade {
    UnidadePrincipal = 1,
    UnidadeSecundaria = 2,
}
